import { render, staticRenderFns } from "./documentHome.vue?vue&type=template&id=396a6e7f&scoped=true&"
import script from "./documentHome.vue?vue&type=script&lang=js&"
export * from "./documentHome.vue?vue&type=script&lang=js&"
import style0 from "./documentHome.vue?vue&type=style&index=0&id=396a6e7f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396a6e7f",
  null
  
)

export default component.exports